const getListItem = (listItemIndex: number) => ({
  list_item_index: listItemIndex
});

export default getListItem;
